/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable camelcase */

import React, { useState } from 'react';
import {
  DialogTrigger,
  ActionButton,
  Dialog,
  Heading,
  Button,
  Item,
  Content,
  ListBox,
  Form,
  Flex,
  Image,
  TextField,
} from '@adobe/react-spectrum';
import AddCircle from '@spectrum-icons/workflow/AddCircle';
import BookmarkSmallOutline from '@spectrum-icons/workflow/BookmarkSmallOutline';
import BookmarkSmall from '@spectrum-icons/workflow/BookmarkSmall';
import { PropTypes } from 'prop-types';
import SearchBoxStyle from './Style';
import TableSearch from './tableResult';

function SearchResult(props) {
  const {
    data,
    count,
    state,
    setImageToBoard,
    isAdobeStock,
    handleLoadMore,
    createUserBoards,
    getUserBoards,
    bookmarkedImages,
    isProjectSearch,
    isTaskSearch,
  } = props;

  const [labelData, setLabelData] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState(new Set());
  const [newBoard, setNewBoard] = useState({
    loading: false,
    currentText: '',
  });

  const toggleLabelData = index => {
    setLabelData([...labelData, index]);
  };
  const { searchText, searchImage, imageSource, searchResult } = data;
  const result = searchImage || searchResult;

  const setCurrentText = text => {
    setNewBoard({ ...state, currentText: text });
  };

  const bookmarkBoards = state?.boards?.map((board, index) => ({
    board,
    index,
  }));

  return (
    <SearchBoxStyle>
      <div>
        {result && result.length > 0 ? (
          <div>
            <div className="searchResultsText">
              <p>
                <span>{result.length || ''}</span> results for{' '}
                <span>{searchText || ''}</span> from <span>{imageSource}</span>
              </p>
            </div>
            {isProjectSearch || isTaskSearch ? (
              <TableSearch
                tableData={data.searchResult}
                isTaskSearch={isTaskSearch}
              />
            ) : (
              <div className="parentGrid">
                {result
                  .slice(0, count)
                  .map(
                    (
                      { id, thumbnail_url, title, externallink, url },
                      index,
                    ) => (
                      <div className="childBox" key={id || title}>
                        <div className="upperBox">
                          <a
                            href={
                              isAdobeStock
                                ? `https://stock.adobe.com/images/cloud-vector-set/${id}`
                                : `${externallink}`
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Image
                              src={isAdobeStock ? thumbnail_url : url}
                              alt={title}
                              height="100%"
                            />
                          </a>
                          <div className="lowerBox">
                            <div className="boardName">
                              {title && !labelData.includes(index)
                                ? title.slice(0, 20)
                                : title}
                              <span onMouseOver={() => toggleLabelData(index)}>
                                {!labelData.includes(index) &&
                                title &&
                                title.length > 20
                                  ? '...'
                                  : ''}
                              </span>
                            </div>
                            <span className="items">
                              <DialogTrigger isDismissable>
                                <ActionButton isQuiet>
                                  {bookmarkedImages?.includes(title) ? (
                                    <BookmarkSmall />
                                  ) : (
                                    <BookmarkSmallOutline />
                                  )}
                                </ActionButton>
                                {close => (
                                  <Dialog
                                    size="S"
                                    height="size-4600"
                                    width="50%"
                                  >
                                    <Heading>Add to board</Heading>
                                    <Content>
                                      <div className="displayBoard">
                                        {state &&
                                        state.boards &&
                                        state.boards.length > 0 ? (
                                          <ListBox
                                            items={bookmarkBoards}
                                            selectionMode="single"
                                            onSelectionChange={selected =>
                                              setSelectedBoard(selected)
                                            }
                                            width="size-2400"
                                          >
                                            {item => (
                                              <Item key={item.board}>
                                                {item.board}
                                              </Item>
                                            )}
                                          </ListBox>
                                        ) : (
                                          <h1 style={{ paddingLeft: '5px' }}>
                                            Empty board
                                          </h1>
                                        )}
                                      </div>
                                      <div className="buttonGrp">
                                        <DialogTrigger
                                          type="modal"
                                          isDismissable
                                        >
                                          <ActionButton isQuiet>
                                            <AddCircle
                                              color="informative"
                                              size="XS"
                                            />
                                            <p style={{ color: '#3a53e8' }}>
                                              Add new board
                                            </p>
                                          </ActionButton>
                                          {closeMe => (
                                            <Dialog>
                                              <Heading>
                                                Create New Board
                                              </Heading>
                                              <Content>
                                                <Form>
                                                  <Flex gap="size-150" wrap>
                                                    <TextField
                                                      width="size-5000"
                                                      aria-label="textfield"
                                                      placeholder="Board Name"
                                                      onChange={setCurrentText}
                                                    />
                                                    <Button
                                                      href="#/search"
                                                      UNSAFE_className="dropdown-item"
                                                      onPress={() => {
                                                        createUserBoards(
                                                          newBoard.currentText,
                                                        );
                                                        getUserBoards();
                                                        closeMe();
                                                      }}
                                                    >
                                                      Create Board
                                                    </Button>
                                                  </Flex>
                                                </Form>
                                              </Content>
                                            </Dialog>
                                          )}
                                        </DialogTrigger>

                                        <Button
                                          variant="cta"
                                          onPress={() => {
                                            setImageToBoard(
                                              isAdobeStock
                                                ? thumbnail_url
                                                : url,
                                              isAdobeStock
                                                ? `https://stock.adobe.com/images/cloud-vector-set/${id}`
                                                : externallink,
                                              title,
                                              [...selectedBoard][0],
                                            );
                                            close();
                                          }}
                                        >
                                          Done
                                        </Button>
                                      </div>
                                    </Content>
                                  </Dialog>
                                )}
                              </DialogTrigger>
                            </span>
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                {result.length > count ? (
                  <Button
                    top="size-200"
                    left="45%"
                    onPress={() => handleLoadMore(result)}
                  >
                    See more
                  </Button>
                ) : null}
              </div>
            )}
          </div>
        ) : (
          <div className="searchResultsText">
            {' '}
            <h1>No results found</h1>
          </div>
        )}
      </div>
    </SearchBoxStyle>
  );
}

SearchResult.propTypes = {
  data: PropTypes.object,
  count: PropTypes.number,
  state: PropTypes.object,
  setImageToBoard: PropTypes.func,
  isAdobeStock: PropTypes.bool,
  handleLoadMore: PropTypes.func,
  createUserBoards: PropTypes.func,
  getUserBoards: PropTypes.func,
  bookmarkedImages: PropTypes.array,
  isProjectSearch: PropTypes.bool,
  isTaskSearch: PropTypes.bool,
};

SearchResult.defaultProps = {
  data: {},
  count: '',
  state: {},
  setImageToBoard: () => {},
  isAdobeStock: true,
  handleLoadMore: () => {},
  createUserBoards: () => {},
  getUserBoards: () => {},
  bookmarkedImages: [],
  isProjectSearch: false,
  isTaskSearch: false,
};
export default SearchResult;
